import { VisuallyHidden, Text, TextProps, Flex } from '@chakra-ui/react';
import { IconDefinition } from '@fortawesome/fontawesome-svg-core';
import { Icon } from './';

type IconStatProps = TextProps & {
   icon: IconDefinition;
   accessibilityLabel: string;
};

/**
 * A component for a semantic Icon accompanied by a label, both of which
 *   are hidden from screen readers, and replaced by an accessible label.
 */
export function IconStat({ accessibilityLabel, icon, children, ...textProps }: IconStatProps) {
   return (
      <Text as="div" variant="muted" textAlign="center" {...textProps}>
         <Flex alignItems="center" justifyContent="center" flexWrap="wrap">
            <Icon type={icon} mx={{ base: 1, sm: 2 }} />
            <span aria-hidden="true">{children}</span>
            <VisuallyHidden>{accessibilityLabel}</VisuallyHidden>
         </Flex>
      </Text>
   );
}
